import React, { Fragment } from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import translate from '../../other/translate.json';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormLabel from '@material-ui/core/FormLabel';

const CustomRadio = withStyles({
  root: {
    color: '#F6F6FB',
    '&$checked': {
      color: '#EB505E',
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

export default function FilterStatuses(props) {
  const classes = useStyles();
  const language = localStorage.getItem('language') || 'Ru';


  return (
    <React.Fragment>
      <FormControl component="fieldset">
        <FormLabel component="legend" focused={false} className={classes.header}>{translate.Words[`Statuses${language}`]}:</FormLabel>

        <RadioGroup aria-label="g" name="g1" value={props.value} onChange={props.handleChange}>
          <FormControlLabel className={classes.label} value={1} control={<CustomRadio />} label={translate.Words[`All${language}`]} />
          {
            !props.isRBS  && !props.isArchive
            ?
            <FormControlLabel className={classes.label} value={2} control={<CustomRadio />} label={translate.Words[`DemandUnderResearch${language}`]} />
            :
            null
            }
          {
             !props.isArchive
            ?
            <FormControlLabel className={classes.label} value={3} control={<CustomRadio />} label={translate.Words[`ComingSoon${language}`]} />
            :
            null
          }
          <FormControlLabel className={classes.label} value={4} control={<CustomRadio />} label={translate.Words[`ReadyToUse${language}`]} />
        </RadioGroup>
      </FormControl>
    </React.Fragment >
  )
}

const useStyles = makeStyles(theme => ({
  header: {
    marginTop: 20,
    marginBottom: 10,
    fontWeight: 500,
    fontSize: '18px',
    lineHeight: '28px',
    color: '#24262A'
  },

  label: {
    color: '#8987A2'
  }
}))